import { makeObservable, observable, action } from 'mobx'

class LiquidationListItem {
    constructor({
        id,
        title,
        period,
        total,
        items,
        status,
        ...rest
    } = {}) {
        this.id = id
        this.title = title
        this.period = period
        this.total = total
        this.items = items
        this.status = status
        Object.assign(this, rest)
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    static fromJson(json) {
        return new LiquidationListItem(json)
    }
}

export default LiquidationListItem
